import { Home } from "../../components/backgrounds/Home";
import { PersonalDataV1 } from "../../components/legal/PolicyData/PersonalDataV1";
import { PersonalDataV2 } from "../../components/legal/PolicyData/PersonalDataV2";

export function DataPage() {
  return (
    <>
      <div className="relative bg-white overflow-hidden">
        <Home
          title={"Política de privacidad y tratamiento de datos personales"}
        />
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div
            className="relative h-full text-lg max-w-prose mx-auto"
            aria-hidden="true"
          ></div>
        </div>
      </div>
      <PersonalDataV2 />
    </>
  );
}
